module.exports = __webpack_public_path__ + "static/img/banner_img5.948981b.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/index/banner_img5.png
// module id = +HSy
// module chunks = 0